// src/pages/LessonManager.js
import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  doc,
  deleteDoc
} from "firebase/firestore";

function LessonManager() {
  const [lessonName, setLessonName] = useState("");
  const [lessons, setLessons] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState(null);
  const [classes, setClasses] = useState([]);

  const fetchClasses = async () => {
    const snapshot = await getDocs(collection(db, "classes"));
    const classList = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setClasses(classList);
    if (!selectedClassId && classList.length > 0) {
      setSelectedClassId(classList[0].id); // İlk sınıf varsayılan seçili
    }
  };

  const fetchLessons = async () => {
    if (!selectedClassId) return;
    const q = query(collection(db, "lessons"), where("classId", "==", selectedClassId));
    const snapshot = await getDocs(q);
    const lessonList = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setLessons(lessonList);
  };

  useEffect(() => {
    fetchClasses();
  }, []);

  useEffect(() => {
    fetchLessons();
  }, [selectedClassId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (lessonName.trim() === "" || !selectedClassId) return;

    await addDoc(collection(db, "lessons"), {
      name: lessonName,
      classId: selectedClassId,
    });
    setLessonName("");
    fetchLessons();
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, "lessons", id));
    fetchLessons();
  };

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2 style={{ marginBottom: "20px" }}>📚 Ders Ekle</h2>

      <div style={{ marginBottom: "20px" }}>
        <label>
          Sınıf Seç: &nbsp;
          <select
            value={selectedClassId || ""}
            onChange={(e) => setSelectedClassId(e.target.value)}
            style={{ padding: "8px", borderRadius: "5px" }}
          >
            {classes.map((cls) => (
              <option key={cls.id} value={cls.id}>
                {cls.name}
              </option>
            ))}
          </select>
        </label>
      </div>

      <form onSubmit={handleSubmit} style={{ marginBottom: "30px" }}>
        <input
          type="text"
          placeholder="Ders adı"
          value={lessonName}
          onChange={(e) => setLessonName(e.target.value)}
          style={{
            padding: "10px",
            fontSize: "16px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            marginRight: "10px",
            width: "250px",
          }}
        />
        <button
          type="submit"
          style={{
            padding: "10px 20px",
            backgroundColor: "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Ekle
        </button>
      </form>

      <ul style={{ listStyle: "none", padding: 0 }}>
        {lessons.map((lesson) => (
          <li
            key={lesson.id}
            style={{
              marginBottom: "15px",
              backgroundColor: "#f0f0f0",
              padding: "10px 20px",
              borderRadius: "8px",
              display: "inline-block",
              minWidth: "300px",
            }}
          >
            <strong>{lesson.name}</strong>
            <div style={{ marginTop: "10px" }}>
              <button
                onClick={() => handleDelete(lesson.id)}
                style={{
                  padding: "6px 14px",
                  backgroundColor: "#dc3545",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Sil
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default LessonManager;
